/**
 * MI technique label stripping.
 *
 * Claude emits Motivational Interviewing technique labels between ampersands,
 * e.g. `&open question&` or `**&affirmation&**`. These are stripped before
 * display.
 *
 * Stripping is keyed to the fixed list below — NOT a generic `&...&` pattern —
 * so HTML entities (&nbsp;, &amp;) and `&` chars inside content-tag JSON
 * (e.g. video URL query strings) are never matched and cannot be corrupted.
 */

export const MI_TECHNIQUES = [
  'open question',
  'affirmation',
  'reflection',
  'summary',
  'reframe',
  'rolling with resistance',
  'exploring ambivalence',
  'elicit change talk',
  'develop discrepancy'
];

/**
 * Removes `&technique&` and `**&technique&**` labels for known MI techniques.
 * @param {string} value - text to clean
 * @returns {string} text with MI technique labels removed (not trimmed)
 */
export function stripMITechniqueLabels(value) {
  if (!value) return value;
  const alternation = MI_TECHNIQUES.join('|');
  const miRegex = new RegExp(`\\*{0,2}&\\s*(?:${alternation})\\s*&\\*{0,2}`, 'gi');
  return value.replace(miRegex, '');
}
